import { ChangeDetectionStrategy, Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FiDialogsContentBase } from '@fi-shared/fi-dialogs/fi-dialogs-content-base';

@Component({
    selector: 'fi-news-feed-pin-settings-dialog',
    template: `
        <p>{{ 'post.pin_settings_dialog_text' | fiAppText }}</p>
        <br />
        <fi-date-picker
            [(ngModel)]="newPinUntil"
            [minDate]="minDate"
            [placeholder]="'post.pin_settings_dialog_input_tooltip' | fiAppText"
            [dateMode]="true"
        >
        </fi-date-picker>
    `,
    styleUrls: ['./fi-news-feed-pin-settings-dialog.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: { class: 'fi-news-feed-pin-settings-dialog' },
    standalone: false,
})
export class FiNewsFeedPinSettingsDialogComponent extends FiDialogsContentBase<Date, Date> implements OnInit {
    newPinUntil: Date;
    minDate: Date;

    ngOnInit(): void {
        const now = new Date();
        this.newPinUntil = (() => {
            if (this.data) return this.data;
            return new Date(Date.UTC(now.getFullYear(), now.getMonth(), now.getDate() + 7));
        })();

        this.minDate = new Date(Date.UTC(now.getFullYear(), now.getMonth(), now.getDate()));
    }

    getResult(): Date {
        return this.newPinUntil;
    }

    isYesButtonDisabled(): boolean {
        return !this.newPinUntil;
    }
}
